export const maritalStatusList = ['Casado', 'Soltero', 'Concubinato', 'Viudo', 'Divorciado']
